export interface TelemetryEvent { event_type: string; payload?: Record<string, unknown>; question_id?: string | null }

// Liga listeners de cola (paste grande, troca de aba, blur) e empurra eventos
// para o buffer fornecido. Retorna função de cleanup.
export function attachTelemetry(push: (e: TelemetryEvent) => void) {
  const onPaste = (e: ClipboardEvent) => {
    const len = (e.clipboardData?.getData("text") || "").length;
    if (len > 40) push({ event_type: "large_paste", payload: { len } });
  };
  const onVis = () => push({ event_type: document.hidden ? "tab_hidden" : "tab_visible" });
  const onBlur = () => push({ event_type: "window_blur" });
  document.addEventListener("paste", onPaste, true);
  document.addEventListener("visibilitychange", onVis);
  window.addEventListener("blur", onBlur);
  return () => {
    document.removeEventListener("paste", onPaste, true);
    document.removeEventListener("visibilitychange", onVis);
    window.removeEventListener("blur", onBlur);
  };
}
